const ReferenceEmailVariableSchemaPlugin = {
  name: 'Discovery email variable reference schema plugin',
  schema: {
    'email-variable-reference': {
      isVoid: true,
      isInline: true,
    },
  },
};

export default ReferenceEmailVariableSchemaPlugin;
